import { useEffect } from "react";

import { useAppSelector } from "~/app/store";
import envConstants from "~/config/envConstants";

import {
  selectAuth0UserId,
  selectUsersClientId,
  selectUsersProfileName,
  selectUsersRoleString
} from "~/redux/selectors/authSelectors";

type BeamerConfig = {
  product_id: string;
  user_firstname: string;
  user_lastname: string;
  user_id: string;
  client_id: string;
  roles: string;
  callback: () => void;
};

declare global {
  interface Window {
    beamer_config?: BeamerConfig;
  }
}

const BEAMER_SCRIPT_SRC = "https://app.getbeamer.com/js/beamer-embed.js";

export const useBeamer = () => {
  const userId = useAppSelector(selectAuth0UserId) || "";
  const clientId = useAppSelector(selectUsersClientId) || "";
  const profileName = useAppSelector(selectUsersProfileName) || "";
  const rolesString = useAppSelector(selectUsersRoleString) || "";

  useEffect(() => {
    if (!userId || !envConstants.BEAMER_PRODUCT_ID) return;

    window.beamer_config = {
      product_id: envConstants.BEAMER_PRODUCT_ID,
      user_firstname: profileName,
      user_lastname: "",
      user_id: userId,
      client_id: clientId,
      roles: rolesString,
      callback: () => {
        const beamerSelector = document.getElementById("beamerSelector");
        if (beamerSelector) {
          beamerSelector.style.display = "none";
        }
      }
    };

    const existingBeamerScript = document.querySelector<HTMLScriptElement>(
      `script[src="${BEAMER_SCRIPT_SRC}"]`
    );
    if (existingBeamerScript) return;

    const beamerScript = document.createElement("script");
    beamerScript.src = BEAMER_SCRIPT_SRC;
    beamerScript.async = true;
    document.body.appendChild(beamerScript);
  }, [userId, clientId, profileName, rolesString]);
};

export default useBeamer;
